import { render, staticRenderFns } from "./DykProductEditorCard.vue?vue&type=template&id=46e0c542&"
import script from "./DykProductEditorCard.vue?vue&type=script&lang=js&"
export * from "./DykProductEditorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports